import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, FormGroup, FormText, Input, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, InputGroupAddon} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions, formatTelefone, formatarReal} from "../../../utils/formatar";
import NumberFormat from "react-number-format";

@inject("store")
@observer
export class JustificativaExcecaoForm extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    render() {
        const solicitacao = this.props.controller.solicitacao;
        const exibeCheckboxSolicitacaoExcecao = this.props.controller.exibeCheckboxSolicitacaoExcecao;
        
        return (
            <Row>
                {exibeCheckboxSolicitacaoExcecao &&
                <Col xs={12} md={12} lg={12}>
                    <FormGroup check className="checkbox-title">
                        <Label check>
                            <Input type="checkbox"
                                   checked={solicitacao.solicitacaoExcecao}
                                   onChange={() => this.props.controller.toggleIsExcecao()}/>{' '}
                            <span>Solicitação de exceção</span>
                        </Label>
                    </FormGroup>
                </Col>
                }
                {solicitacao.solicitacaoExcecao && (
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup>
                            <Label>Justificativa para a solicitação de exceção <sup>*</sup></Label>
                            <Input type="textarea" maxLength={512}
                                   value={solicitacao.justificativaExcecao}
                                   onChange={(event) => this.props.controller.setJustificativaExcecao(event.target.value)}/>
                            <Validacao id="justificativaSolicitacao" valor={solicitacao.justificativaExcecao}
                                       tipo={["isRequired"]}/>
                        </FormGroup>
                    </Col>
                )}
            </Row>
        )
    }
}